export enum Source {
    PLUGIN = 'plugin',
    PORTFOLIO = 'portfolio',
    STANDALONE = 'standalone', // For widgets running as standalone apps (except for portfolio)
}

export const WidgetType = {
    PORTFOLIO: 'portfolio',
    MAP_WIDGET: 'map_widget',
    NEIGHBORHOOD_WIDGET: 'neighborhood_widget',
    PAGE_WIDGET: 'page_widget',
    SEO_WIDGET: 'seo_widget',
    BUMP_OUT_WIDGET: 'bump_out_widget',
} as const;

export type WidgetType = (typeof WidgetType)[keyof typeof WidgetType];

// Version 1 is the legacy version and only used by the AWS Migration, don't use it for new code
// As new versions are created add them to this option list eg Version = 2 | 3 | 4
export type Version = 2;

export * from './UserSession';
export * from './UserAction';
